import { EnrollmentRequiredDocumentType } from "../../../types/EnrollmentRequiredDocument";
import { put } from "../../../utils/axios-config";
import { ENROLLMENT_REQUIRED_DOCUMENTS } from "../../../utils/constants";

export const updateEnrollmentRequiredDocument = async (data:EnrollmentRequiredDocumentType) => {
    return await put<EnrollmentRequiredDocumentType, string>(ENROLLMENT_REQUIRED_DOCUMENTS, data);
};